import { render, staticRenderFns } from "./taskItemPopover.vue?vue&type=template&id=9eafa9ba&"
import script from "./taskItemPopover.vue?vue&type=script&lang=js&"
export * from "./taskItemPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports